// extracted by mini-css-extract-plugin
export default {"aboutUs":"about_aboutUs__HtyG-","content":"about_content__lbdFX","greenText":"about_greenText__QuduB"};